import * as Updates from 'expo-updates';

/**
 * CANAL DE LIVRAISON — « dans quel contexte cette copie de l'application tourne-t-elle ? »
 *
 * Extrait de `services/sentry.ts`, où il s'appelait `canalSentry` et où il ne pouvait pas rester :
 * la question n'a rien de propre à la télémétrie. Le garde-fou Stripe s'en sert désormais, et un
 * garde-fou de PAIEMENT qui interroge une fonction nommée d'après Sentry est une ligne que le
 * prochain lecteur croira pouvoir supprimer.
 *
 * D'OÙ VIENT LA RÉPONSE, dans l'ordre :
 *  1. `EXPO_PUBLIC_SENTRY_ENV` — la déclaration explicite. C'est elle qu'un déploiement web doit
 *     poser, puisque rien d'autre ne peut le savoir à sa place. Elle est INLINÉE À L'EXPORT : la
 *     poser à l'exécution n'a aucun effet.
 *  2. `Updates.channel` — posé par EAS depuis `eas.json` : `development`, `preview` ou
 *     `production`. Sur un build EAS c'est la vérité, et elle n'est pas devinée.
 *  3. `local` — ni l'un ni l'autre : on n'est pas passé par EAS. Volontairement DIFFÉRENT de
 *     `development`, qui est un vrai canal : un build dev-client et un `expo start` sur un poste
 *     ne sont pas le même contexte.
 *
 * POURQUOI PAS `__DEV__`. Il ne répond pas à cette question-là. Il est faux dans TOUT build non
 * débogué — `preview` compris — et l'employer comme substitut de « production » était l'erreur
 * exacte du garde-fou Stripe, confirmée sur appareil le 20/09/2026 : un build `preview`, dont la
 * clé de test est parfaitement voulue, se signalait comme une faute de configuration.
 */
export function canalDeLivraison(): string {
  // EXPO_PUBLIC_OPTIONNEL: seul moyen de nommer le canal là où `expo-updates` n'en fournit pas —
  // c'est-à-dire sur le WEB, où `Updates.channel` est toujours absent. Son absence vaut `local`.
  const declare = process.env.EXPO_PUBLIC_SENTRY_ENV?.trim();
  return declare || Updates.channel?.trim() || 'local';
}

/** Le seul canal où une configuration de test est une faute, et non une intention. */
export function estProduction(): boolean {
  return canalDeLivraison() === 'production';
}
